import api from '../api'
import axios from 'axios'
import endpoint from '../endpoint';
import router from '../../router';

class UserService {

    async login(username, password) {
        return await axios.post(`${endpoint}/auth/login`, { email: username, password }, {
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            if (response.data.token) {
                localStorage.setItem('ENSPSID', response.data.token);
            }
            return response.data;
        });
    }

    async logout() {
        return await api.post('/auth/logout').then(response => {
            localStorage.removeItem('user');
            localStorage.removeItem('ENSPSID');
            return response.data;
        });
    }

    async verifyUser() {
        return await api.get('/auth/verify_token').then(response => {
            return response.data;
        }).catch(() => {
            router.push('/login');
        });
    }

    async createUser(user) {
        const name = user.name ?? ((user.firstname ?? '') + ' ' + (user.lastname ?? '')).trim();
        return await api.post('/auth/register', {
            name: name,
            email: user.email ?? null,
            password: user.password,
            position: user.position ?? 'Staff',
            role_id: user.role_id ?? null,
        }, { headers: { 'Content-Type': 'application/json' } }).then(
            response => response.data
        );
    }

    async editUser(user) {
        return await api.put(`/update-user/${user.id}`, {
            name: user.name,
            email: user.email,
            position: user.position,
            password: user.password,
        }).then(response => response.data);
    }

    async forgotPassword(email) {
        return await axios.post(`${endpoint}/auth/sendResetPasswordCode`, { email }, {
            headers: { 'Content-Type': 'application/json' }
        }).then(response => response.data);
    }

    async verifyOTP(code) {
        return await axios.post(`${endpoint}/auth/checkCode`, { code: code.toString() }, {
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            // Store OTP code in localStorage with the same key convention as auth token
            localStorage.setItem('ENSPSID_OTP', JSON.stringify(code));
            return response.data;
        });
    }

    async resetPassword(password) {
        const code = localStorage.getItem('ENSPSID_OTP');
        return await axios.post(`${endpoint}/auth/passwordReset`, {
            code: code ? code.toString() : '',
            password: password
        }, { headers: { 'Content-Type': 'application/json' } }).then(response => {
            localStorage.removeItem('ENSPSID_OTP');
            return response.data;
        });
    }

    async changePassword(form) {
        return await api.post('/auth/change-password', {
            old_password: form.old,
            new_password: form.new
        }).then(response => response.data);
    }

    async getAllUsers() {
        return await api.get('/users').then(response => response.data);
    }

    async getUser(id) {
        return await api.get(`/user/${id}`).then(response => response.data);
    }

    async getRoles() {
        return await api.get('/roles').then(r => r.data);
    }

    async getAllPermissions() {
        return await api.get('/all_permissions').then(r => r.data);
    }

    async createRole(name, permissions) {
        return await api.post('/create_role', { name, permissions }).then(r => r.data);
    }

    async updateRole(id, name, permissions) {
        return await api.post(`/update_role/${id}`, { name, permissions }).then(r => r.data);
    }

    async deleteRole(id) {
        return await api.post(`/delete_role/${id}`).then(r => r.data);
    }

    async assignRole(userId, roles) {
        return await api.post('/assign_role', { user_id: userId, roles }).then(r => r.data);
    }

    async getUserRoles(userId) {
        return await api.get(`/user_roles/${userId}`).then(r => r.data);
    }

    async seedDefaults() {
        return await api.post('/seed_defaults').then(r => r.data);
    }

    async addUserPermission(permission) {
        return await api.post('/add-permissions', { permission }).then(response => response.data);
    }

    async deleteUserPermission(id) {
        return await api.post('/delete-permissions', { id }).then(response => response.data);
    }

    async getPermissions() {
        return await api.get('/permissions').then(response => response.data);
    }

    async updateUserPermissions(permissions, id) {
        return await api.post('/update_permissions', {
            permissions: permissions,
            user_id: id
        }).then(response => response.data);
    }
}

export default new UserService();
